import { useQueryWithUserId } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';

/**
 * This is to track the credit limit detail in react query cache.
 */
export const CREDIT_LIMIT_QUERY_KEY = 'credit-limit-query-key';

/**
 * This hook fetches the credit limit details using storeId.
 */
export const useCreditLimitQuery = (storeId: string) => {
  const { data, isPending, isFetching, isError, error, refetch } =
    useQueryWithUserId({
      queryKey: [CREDIT_LIMIT_QUERY_KEY, storeId],
      enabled: !!storeId,
      queryFn: () => CUSTOMER_SERVICE_API.fetchCreditLimit(storeId),
    });

  return {
    data,
    error,
    isError,
    isFetching,
    isPending,
    refetch,
  };
};
